import React, { useEffect, useState } from "react";
import Modal from "../shared/Modal";
import "./ModalTextInput.css";
import PolicyStudioActionButton from "./components/PolicyStudioActionButton";

interface ModalTextInputProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (value: string) => void;
  value: string;
  title: string;
  inputPlaceholder: string;
  label?: string;
  escapeToClose?: boolean;
  allowClickout?: boolean;
  canClose?: boolean;
  autofocus?: boolean;
}

export const ModalTextInput: React.FC<ModalTextInputProps> = ({
  title,
  isOpen,
  onClose,
  onSubmit,
  value,
  inputPlaceholder,
  label,
  escapeToClose = true,
  allowClickout = true,
  canClose = true,
  autofocus = false,
}) => {
  const [internalValue, setInternalValue] = useState<string>(value);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const handleSubmit = () => {
    if (internalValue) {
      onSubmit(internalValue);
      if (canClose) {
        onClose();
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "500px" }}
      canClose={canClose}
      escapeToClose={escapeToClose}
      allowClickout={allowClickout}>
      <div className="modal-text-input">
        <div className="modal-text-input-title">
          <h2>{title}</h2>
        </div>
        <div className="modal-text-input-body">
          {label && <div className="modal-text-input-label">{label}</div>}
          <div className="modal-text-input-content">
            <input
              type="text"
              value={internalValue}
              onChange={(e) => setInternalValue(e.target.value)}
              placeholder={inputPlaceholder}
              autoFocus={autofocus}
            />
          </div>
        </div>
        <div className="modal-text-input-buttons">
          {canClose && (
            <PolicyStudioActionButton
              label="Cancel"
              variant="primary"
              onClick={onClose}
            />
          )}
          <PolicyStudioActionButton
            label="Submit"
            variant="tertiary"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};
